import { render, staticRenderFns } from "./menu1_2.vue?vue&type=template&id=aa4990d8&scoped=true&"
import script from "./menu1_2.vue?vue&type=script&lang=js&"
export * from "./menu1_2.vue?vue&type=script&lang=js&"
import style0 from "./menu1_2.vue?vue&type=style&index=0&id=aa4990d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4990d8",
  null
  
)

export default component.exports